import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconsModule } from '@epicuro-next/ataraxia/icons';
import { ImageModule } from '@epicuro-next/ataraxia/image';
import { MediaPreviewModule } from '@epicuro-next/ataraxia/media-preview';
import { ModalModule } from '@epicuro-next/ataraxia/modal';
import { StepperModule } from '@epicuro-next/ataraxia/stepper';
import { OnboardingStateModule } from '@epicuro-next/state/onboarding';
import { StateSitesStateModule } from '@epicuro-next/state/site-state';
import { LetDirective, PushPipe } from '@ngrx/component';

import { OnboardingItemComponent } from './components/onboarding-item/onboarding-item.component';
import { OnboardingComponent } from './components/onboarding/onboarding.component';

@NgModule({
  declarations: [OnboardingComponent, OnboardingItemComponent],
  imports: [
    CommonModule,
    ModalModule,
    IconsModule,
    ImageModule,
    StepperModule,
    StateSitesStateModule,
    OnboardingStateModule,
    MediaPreviewModule,
    ImageModule,
    LetDirective,
    PushPipe,
  ],
  exports: [OnboardingComponent],
})
export class OnboardingModule {}
